import React, { useEffect } from "react";

const stack = [];
import { ChevronLeft } from "lucide-react";

/** Resident portal: every board opens as its own full screen with Back (no long scrolling pages). */
export function PortalScreen({ title, onBack, children, testid }) {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const me = {};
    stack.push(me);
    const esc = (e) => e.key === "Escape" && stack[stack.length - 1] === me && onBack();
    window.addEventListener("keydown", esc);
    return () => { stack.splice(stack.indexOf(me), 1); document.body.style.overflow = prev; window.removeEventListener("keydown", esc); };
  }, [onBack]);
  return (
    <div data-testid={testid || "portal-screen"} className="fixed inset-0 z-50 bg-[#0b0814] text-white flex flex-col animate-in fade-in slide-in-from-right-4 duration-200">
      <header className="flex items-center gap-2 px-2 border-b border-white/10 pt-[env(safe-area-inset-top)]">
        <button type="button" onClick={onBack} data-testid="portal-screen-back" className="inline-flex items-center gap-1 px-2 py-3 text-xs uppercase tracking-[0.2em] text-white/70 hover:text-[#d4a017]">
          <ChevronLeft className="h-5 w-5" /> Back
        </button>
        <h1 data-testid="portal-screen-title" className="flex-1 truncate text-base font-semibold">{title}</h1>
      </header>
      <div className="phone-screen flex-1 min-w-0 overflow-y-auto overflow-x-hidden overscroll-contain touch-pan-y px-4 py-5 pb-[max(1.25rem,env(safe-area-inset-bottom))]">
        <div className="max-w-2xl mx-auto space-y-4">{children}</div>
      </div>
    </div>
  );
}

/** Big tap target on a tab that opens a PortalScreen. */
export function Tile({ icon: Icon, label, sub, onClick, testid, accent }) {
  return (
    <button type="button" onClick={onClick} data-testid={testid}
      className={`text-left rounded-md border p-4 transition-colors min-h-[92px] flex flex-col justify-between ${accent ? "border-[#d4a017]/60 bg-[#d4a017]/10 hover:bg-[#d4a017]/20" : "border-white/10 bg-white/[0.03] hover:border-white/30"}`}>
      <Icon className="h-5 w-5 text-[#d4a017]" />
      <span><span className="block font-semibold text-sm">{label}</span>{sub && <span className="block text-xs text-white/50 truncate">{sub}</span>}</span>
    </button>
  );
}
